// // Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// // TODO: Add SDKs for Firebase products that you want to use
// // https://firebase.google.com/docs/web/setup#available-libraries

// Change this if you want to change firebase
const firebaseConfig = {
    apiKey: "AIzaSyDYNZreThCjbWmH-Auf0Op3YGldoyRy74s",
    authDomain: "easyquickorder-40d5d.firebaseapp.com",
    projectId: "easyquickorder-40d5d",
    storageBucket: "easyquickorder-40d5d.firebasestorage.app",
    messagingSenderId: "830944605689",
    appId: "1:830944605689:web:7bafef804a585966593928",
    measurementId: "G-8K691CLR7X"
};



// // Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Cloud Firestore and get a reference to the service

export const db = getFirestore(app);

export const auth = getAuth(app);
// export default db;
